/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';

/**
 * Asigna un elemento a una ref  de manera segura manteniendo la compatibilidad
 * entre Object Refs y Callback Refs: https://es.reactjs.org/docs/refs-and-the-dom.html
 */
function attachRef(ref, val) {
  if (typeof ref === 'function') {
    ref(val);
  } else if (ref !== null) {
    ref.current = val;
  }
}

/**
 * Permite forkear la ref de manera segura sin memory leaks
 */
function forkRef(refOne, refTwo) {
  return React.useMemo(() => {
    if (refOne == null && refTwo == null) {
      return null;
    }
    return instance => {
      attachRef(refOne, instance);
      attachRef(refTwo, instance);
    };
  }, [refOne, refTwo]);
}

export { attachRef, forkRef };
